(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserProfileDialogController', UserProfileDialogController);

    UserProfileDialogController.$inject = ['$state', '$scope', 'entity', 'UserProfile', 'Authority','TabDomains', 'Principal'];

    function UserProfileDialogController ($state, $scope, entity, UserProfile, Authority, TabDomains, Principal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.userProfile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.slider;
        vm.floor = 5;
        vm.gap = 4;
        vm.customizable=false;

        function loadAll(){
            if(vm.userProfile.id == null || vm.userProfile.id == "null") {
                vm.userProfile.authority = {};
                vm.userProfile.authority.name = "ROLE_DOMAIN_USER";
                vm.userProfile.customProfile = true;
            }
            Principal.hasAuthority("ROLE_ADMIN").then(function (isAdmin){
                if(isAdmin){
                    TabDomains.query().$promise.then(function (domains) {
                        vm.domains = domains;
                    });
                }
            });
            vm.limitLevel();
        }

        function clear () {
            $state.go('user-profile');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userProfile.id !== null) {
                UserProfile.update(vm.userProfile, onSaveSuccess, onSaveError);
            } else {
                UserProfile.save(vm.userProfile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jotApp:userProfileUpdate', result);
            vm.isSaving = false;
            $state.go('user-profile');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.limitLevel = function() {
            vm.slider = {};
            if(vm.userProfile.authority.name == 'ROLE_ADMIN') {
                vm.slider = {
                    options: {
                        floor: 1,
                        ceil: 10,
                        step: 1,
                        minLimit: 0,
                        maxLimit: 0,
                        rightToLeft: true
                    }
                };
                vm.slider.options.stepsArray = [{value: 1, legend: 'High'}, {value: 2}, {value: 3}, {value: 4}, {value: 5}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10, legend: 'Low'}];
            }
            else if(vm.userProfile.authority.name == 'ROLE_TECH') {
                vm.slider = {
                    options: {
                        floor: 1,
                        ceil: 10,
                        step: 1,
                        minLimit: 1,
                        maxLimit: 2,
                        rightToLeft: true
                    }
                };
                vm.slider.options.stepsArray = [{value: 1, legend: 'High'}, {value: 2}, {value: 3}, {value: 4}, {value: 5}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10, legend: 'Low'}];
            }
            else if(vm.userProfile.authority.name == 'ROLE_DOMAIN_ADMIN') {
                vm.slider = {
                    options: {
                        floor: vm.floor,
                        ceil: 10,
                        step: 1,
                        minLimit: 3 - vm.gap,
                        maxLimit: 3 - vm.gap,
                        rightToLeft: true
                    }
                };
                vm.slider.options.stepsArray = [{value: 4, legend: 'High'}, {value: 5}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10, legend: 'Low'}];
            }
            else if(vm.userProfile.authority.name == 'ROLE_DOMAIN_USER') {
                vm.customizable=true;
                vm.slider = {
                    options: {
                        floor: vm.floor,
                        ceil: 10,
                        step: 1,
                        minLimit: 4 - vm.gap,
                        maxLimit: 9 - vm.gap,
                        rightToLeft: true
                    }
                };
                vm.slider.options.stepsArray = [{value: 5, legend: 'High'}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10, legend: 'Low'}];
            }
            vm.slider.options.showTicksValues = true;
            $scope.$broadcast('rzSliderForceRender');
        };

        vm.loadAll();

    }
})();
